@switch (accessState()) {
  @case ('authorized') {
    <div class="flex min-h-screen flex-col">
      <spike-titlebar />
      <div class="flex flex-1">
        <cmt-nav-rail />
        <!-- `min-w-0`: without it this flex item grows to its content's min-content
             width, so any page with a wide element (e.g. a fixed-width table) pushes
             the whole shell — nav rail, header and footer included — into a horizontal
             page scrollbar instead of scrolling inside its own container (EB-4170 H7). -->
        <main class="min-w-0 flex-1">
          <router-outlet />
        </main>
      </div>
      <spike-footer />
    </div>
    <hlm-toast-container />
    <cmt-penguin-overlay />
  }
  @case ('denied') {
    <cmt-access-denied variant="no-role" />
  }
  @case ('denied-error') {
    <cmt-access-denied variant="service-error" />
  }
  @default {
    <div class="bg-background flex min-h-screen items-center justify-center">
      <hlm-spinner size="32" />
    </div>
  }
}
